var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",attrs:{"href":_vm.href,"target":"_blank"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }